import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import {
  ShowErrorToast,
  ShowSuccessToast,
} from "../../components/toaster/toast.jsx";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true); // Start loading
      try {
        const res = await ApiService.forgotPassword({ email: values.email });

        if (res) {
          ShowSuccessToast(res.message);
          navigate("/login");
        }
      } catch (error) {
        console.log("error", error);
        ShowErrorToast(
          error?.response?.data?.error ||
            "Something went wrong, please try again!"
        );
      } finally {
        setLoading(false); // Stop loading
      }
    },
  });

  return (
    <div className="flex flex-col bg-custom-gradient text-white h-screen">
      <div className="px-10 py-3 w-full flex items-center">
        <img src="/images/cards/pacific.png" alt="Company Logo" />
      </div>
      <div className="flex flex-col md:flex-row gap-10 lg:gap-40 md:gap-20 md:items-start sm:items-center justify-center flex-grow pt-5 xl:pt-10 2xl:pt-32 md:px-0 px-6">
        <div className="">
          <h1 className="md:text-4xl text-2xl font-semibold mb-4">
            Forgot Your <br /> Password?
          </h1>
          {/* <p className="text-lg">
          Don’t worry! Enter your email address to reset your password.
        </p> */}
        </div>
        {/* <div className="w-full lg:w-1/2 flex justify-center items-center"> */}
        <div className="bg-white text-gray-900 p-8 rounded-lg shadow-lg w-full lg:w-[343px] lg:h-[222px] max-w-md">
          {/* <h2 className="text-2xl font-semibold mb-6 text-center">
            Reset Password
          </h2> */}
          <form className="space-y-5 my-auto" onSubmit={formik.handleSubmit}>
            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="example@mail.com"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 placeholder:text-[#C8C8C8] focus:ring-blue-500"
              />
              {formik.touched.email && formik.errors.email && (
                <p className="text-red-500 text-sm">{formik.errors.email}</p>
              )}
            </div>
            <div className="flex justify-end">
              <button
                // onClick={handleResetpassword}
                type="submit"
                className="w-full md:w-[40%] bg-orangeColor text-white px-4 py-1.5 rounded-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
        <img
          src="/images/sitar.png"
          alt="Sitar"
          className="absolute bottom-0 left-0 hidden md:block"
        />
        {/* </div> */}
      </div>
      <footer className="sticky bottom-0 text-center py-4 w-full  text-white">
        © 2025 Pacific Cross. All Rights Reserved.
      </footer>
    </div>
  );
};

export default ForgotPassword;
